/**
 * Requête unitaire vers `POST /api/query` (route backend `backend/src/routes/query.ts`).
 *
 * Le builder passe normalement par `useWidgetData` (batch). Le drill-down, lui,
 * interroge une seule dimension à la demande, hors du batch : c'est ce service.
 */
import type { WidgetFilter } from './schemas';
import type { Row, WidgetQueryResult } from './useWidgetData';

export interface ExecuteQueryParams {
  data_source_id: string | number;
  metrics: string[];
  dimensions?: string[];
  filters?: WidgetFilter[];
  filters_logic?: 'and' | 'or';
  start: string;
  end: string;
  granularity?: string;
  compare?: boolean;
  compare_mode?: string;
  compare_start?: string;
  compare_end?: string;
}

export type { Row };

/** Exécute une requête unitaire. Jette l'erreur renvoyée par le backend si la réponse n'est pas ok. */
export async function executeQuery(params: ExecuteQueryParams): Promise<WidgetQueryResult> {
  const res = await fetch('/api/query', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  const json = await res.json();

  if (!res.ok || json?.success === false) {
    throw new Error(json?.error || 'Erreur de requête');
  }

  const data = (json?.data ?? {}) as Partial<WidgetQueryResult>;
  return {
    current: data.current ?? [],
    previous: data.previous ?? null,
    meta: data.meta ?? {},
  };
}
